import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { GraduationCap, LogIn, Menu, X } from "lucide-react";
import Button from "./ui/Button";
import UserMenu from "./layout/UserMenu";

const Navbar = ({ user: mainUser, setUser }) => {
  // const { user,  logout } = useAuthStore();
  // const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const user = useAuthStore((state) => state.user);
const logout = useAuthStore((state) => state.logout);
const isAuthenticated = useAuthStore((state) => state.isAuthenticated);



  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isAdmin = user?.role === "admin"; // Replace as per your role logic

  const HandleLogout = () => {
    localStorage.removeItem("auth");
    logout();
  };

  const navLinkClass = (path) =>
    `text-gray-600 hover:text-indigo-600 transition ${
      location.pathname === path ? "font-semibold text-indigo-600" : ""
    }`;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <GraduationCap className="h-8 w-8 text-indigo-600" />
            <span className="text-2xl font-bold text-gray-900">
              AcademiaHub
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/about" className={navLinkClass("/about")}>
              About Us
            </Link>
            <Link to="/help" className={navLinkClass("/help")}>
              Contact Us
            </Link>
            {(!user || user.role === "student") && (
              <Link to="/courses" className={navLinkClass("/courses")}>
                Find Courses
              </Link>
            )}
           {(!user || user.role === "student") && (
              <Link to="/teachers" className={navLinkClass("/teachers")}>
                Find Teachers
              </Link>
            )}

            {isAuthenticated && isAdmin ? (
              <>
                <UserMenu user={mainUser} setUser={setUser} />
              </>
            ) : isAuthenticated ? (
              <>
                <Link to="/dashboard" className={navLinkClass("/dashboard")}>
                  Dashboard
                </Link>
                <UserMenu user={mainUser} setUser={setUser} />
              </>
            ) : (
              <Link to="/login">
                <Button className="flex items-center space-x-2">
                  <LogIn className="h-4 w-4" />
                  <span>Start Learning</span>
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile Hamburger */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-indigo-600 focus:outline-none"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden flex flex-col px-4 pt-4 pb-6 space-y-3 bg-white shadow-lg">
          <Link to="/about" className={navLinkClass("/about")}>
            About Us
          </Link>
          <Link to="/help" className={navLinkClass("/help")}>
            Contact Us
          </Link>
          {(!user || user.role === "student") && (
            <Link to="/courses" className={navLinkClass("/courses")}>
              Find Courses
            </Link>
          )}
          {(!user || user.role === "student") && (
            <Link to="/teachers" className={navLinkClass("/teachers")}>
              Find Teachers
            </Link>
          )}

          {isAuthenticated && isAdmin ? (
            <>
              <button
                onClick={HandleLogout}
                className="w-full text-left text-gray-600 hover:text-indigo-600"
              >
                Logout
              </button>
            </>
          ) : isAuthenticated ? (
            <>
              <div className="flex justify-between">
                <Link to="/dashboard" className={navLinkClass("/dashboard")}>
                  Dashboard
                </Link>
                <UserMenu user={mainUser} setUser={setUser} />
              </div>
              <button
                onClick={HandleLogout}
                className="w-full text-left text-gray-600 hover:text-indigo-600"
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className={navLinkClass("/login")}>
              Start Learning
            </Link>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
